'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propEnhancers = exports.propValidators = exports.propAliases = exports.propTypes = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getCss = require('../get-css');

var _getCss2 = _interopRequireDefault(_getCss);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = exports.propTypes = {
  color: _propTypes2.default.string,
  font: _propTypes2.default.string,
  fontFamily: _propTypes2.default.string,
  fontSize: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  fontStyle: _propTypes2.default.string,
  fontVariant: _propTypes2.default.string,
  fontWeight: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  letterSpacing: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  lineHeight: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  textAlign: _propTypes2.default.string,
  textDecoration: _propTypes2.default.string,
  textOverflow: _propTypes2.default.string,
  textShadow: _propTypes2.default.string,
  textTransform: _propTypes2.default.string,
  whiteSpace: _propTypes2.default.string,
  wordBreak: _propTypes2.default.string,
  wordWrap: _propTypes2.default.string
};
var propAliases = exports.propAliases = {};
var propValidators = exports.propValidators = {};
var _textAlign = {
  className: 'txt-algn',
  safeValue: true,
  cssName: 'text-align',
  jsName: 'textAlign'
};
var _textDecoration = {
  className: 'txt-deco',
  cssName: 'text-decoration',
  jsName: 'textDecoration'
};
var _textTransform = {
  className: 'txt-trns',
  cssName: 'text-transform',
  jsName: 'textTransform',
  safeValue: true
};
var _textShadow = {
  className: 'txt-shdw',
  cssName: 'text-shadow',
  jsName: 'textShadow',
  complexValue: true
};
var _textOverflow = {
  className: 'txt-ovrf',
  cssName: 'text-overflow',
  jsName: 'textOverflow',
  safeValue: true
};
var _color = {
  className: 'color',
  cssName: 'color',
  jsName: 'color'
};
var _font = {
  className: 'fnt',
  cssName: 'font',
  jsName: 'font',
  complexValue: true
};
var _fontFamily = {
  className: 'fnt-fam',
  cssName: 'font-family',
  jsName: 'fontFamily',
  complexValue: true
};
var _fontSize = {
  className: 'fnt-sze',
  cssName: 'font-size',
  jsName: 'fontSize'
};
var _fontStyle = {
  className: 'fnt-stl',
  cssName: 'font-style',
  jsName: 'fontStyle',
  safeValue: true
};
var _fontVariant = {
  className: 'f-vari',
  cssName: 'font-variant',
  jsName: 'fontVariant'
};
var _fontWeight = {
  className: 'f-wght',
  cssName: 'font-weight',
  jsName: 'fontWeight',
  safeValue: true,
  defaultUnit: ''
};
var _lineHeight = {
  className: 'ln-ht',
  cssName: 'line-height',
  jsName: 'lineHeight',
  defaultUnit: ''
};
var _wordBreak = {
  className: 'wrd-brk',
  cssName: 'word-break',
  jsName: 'wordBreak',
  safeValue: true
};
var _wordWrap = {
  className: 'wrd-wrp',
  cssName: 'word-wrap',
  jsName: 'wordWrap',
  safeValue: true
};
var _whiteSpace = {
  className: 'wht-spc',
  cssName: 'white-space',
  jsName: 'whiteSpace',
  safeValue: true
};
var _letterSpacing = {
  className: 'ltr-spc',
  cssName: 'letter-spacing',
  jsName: 'letterSpacing'
};
var propEnhancers = exports.propEnhancers = {
  color: function color(value) {
    return (0, _getCss2.default)(_color, value);
  },
  font: function font(value) {
    return (0, _getCss2.default)(_font, value);
  },
  fontFamily: function fontFamily(value) {
    return (0, _getCss2.default)(_fontFamily, value);
  },
  fontSize: function fontSize(value) {
    return (0, _getCss2.default)(_fontSize, value);
  },
  fontStyle: function fontStyle(value) {
    return (0, _getCss2.default)(_fontStyle, value);
  },
  fontVariant: function fontVariant(value) {
    return (0, _getCss2.default)(_fontVariant, value);
  },
  fontWeight: function fontWeight(value) {
    return (0, _getCss2.default)(_fontWeight, value);
  },
  letterSpacing: function letterSpacing(value) {
    return (0, _getCss2.default)(_letterSpacing, value);
  },
  lineHeight: function lineHeight(value) {
    return (0, _getCss2.default)(_lineHeight, value);
  },
  textAlign: function textAlign(value) {
    return (0, _getCss2.default)(_textAlign, value);
  },
  textDecoration: function textDecoration(value) {
    return (0, _getCss2.default)(_textDecoration, value);
  },
  textOverflow: function textOverflow(value) {
    return (0, _getCss2.default)(_textOverflow, value);
  },
  textShadow: function textShadow(value) {
    return (0, _getCss2.default)(_textShadow, value);
  },
  textTransform: function textTransform(value) {
    return (0, _getCss2.default)(_textTransform, value);
  },
  whiteSpace: function whiteSpace(value) {
    return (0, _getCss2.default)(_whiteSpace, value);
  },
  wordBreak: function wordBreak(value) {
    return (0, _getCss2.default)(_wordBreak, value);
  },
  wordWrap: function wordWrap(value) {
    return (0, _getCss2.default)(_wordWrap, value);
  }
};